import { render, staticRenderFns } from "./CampusList.vue?vue&type=template&id=6011ea6e"
import script from "../../controllers/campus/campus-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus/campus-list.js?vue&type=script&lang=js&external"
import style0 from "./CampusList.vue?vue&type=style&index=0&id=6011ea6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports